import type { IHome, IListResponse, IPage } from '@xbl/types'
import { request } from '@umijs/max'

/** 获取首页列表 GET /backend/home/list */
export async function homeList(params: IPage) {
  return request<IListResponse<IHome>>('/backend/home/list', {
    method: 'GET',
    params: {
      ...params
    }
  })
}

/** 添加/编辑首页 POST /backend/home/add */
export async function homeAdd(body: IHome) {
  return request<{ data: IHome, status: number, message: string }>('/backend/home/add', {
    method: 'POST',
    data: body
  })
}

/** 设置置顶 PUT /backend/home/set_sticky */
export async function homeSetSticky(body: { id?: number, is_sticky?: boolean }) {
  return request<{ data: IHome }>('/backend/home/set_sticky', {
    method: 'PUT',
    data: body
  })
}

/** 删除首页 DELETE /backend/home/delete */
export async function homeDelete(body: { id?: number }) {
  return request<{ data: IHome }>('/backend/home/delete', {
    method: 'DELETE',
    data: body
  })
}
